import Validator from '../Validator';
import ValidatorInterface from '../ValidatorInterface';

export default class ValidatorMultiple extends Validator implements ValidatorInterface {

    /**
     * Check if value is valid
     *
     * @param value
     * @param index
     * @param offset
     */

    public check(value: string, index: number, offset: number): boolean {

        let integerValue = Number.parseInt(value,10);

        // Check if value can be casted to integer
        if (!Number.isInteger(integerValue)) {
            this.addError("Invalid non integer value found",index, value);
            return false;
        }

        let choiceValue = 1 + offset;

        if (integerValue!=0 && integerValue!=1 && integerValue!==choiceValue) {
            let validValues = choiceValue>1 ? "0,1 and "+choiceValue : "0 and 1";
            this.addError("Valid values are "+validValues+". Invalid value found",index,value);
            return false;
        }

        return true;
    }
}